/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react"
import ContentWrapper from "ui/common/ContentWrapper";
import Header1 from "ui/kit/typography/Header1";
import Body from "ui/kit/typography/Body";
import SignOutButton from "ui/feature/account/SignOutButton";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import query from "ui/feature/account/AccountQuery";
import {AccountQuery} from "ui/feature/account/__generated__/AccountQuery.graphql";

const Account: React.FC = () => {
    return (
        <ContentWrapper>
            <Header1>Account</Header1>
            <QueryRenderer<AccountQuery>
                environment={environment}
                variables={{}}
                query={query}
                render={({props, error}) => {
                    if (props) {
                        return <Body>{props.music_viewer.me.email}</Body>;
                    } else if (error) {
                        return <Body>Error</Body>;
                    } else {
                        return <Body>Loading...</Body>;
                    }
                }}/>
            <SignOutButton/>
        </ContentWrapper>
    )
}

export default Account